import React from 'react';
import { Box, Typography, Grid, Paper, Container, Chip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { styles } from './styles/Home.styles';
import { homeContent } from '../constants/content';

const Home = () => {
  const navigate = useNavigate();
  const { hero, note, about, experience } = homeContent;

  return (
    <Container maxWidth="lg">
      {/* Hero Section */}
      <Box sx={styles.heroContainer}>
        <Box
          component="img"
          src="/images/profile.jpg"
          alt="Kush Patel in the mountains"
          sx={styles.profileImage}
        />
        <Typography variant="h2" sx={styles.gradientText}>
          {hero.name}
        </Typography>
        <Typography variant="h4" color="text.secondary" sx={styles.subtitle}>
          {hero.title}
        </Typography>
        <Typography variant="body2" sx={styles.locationText}>
          {hero.location}
        </Typography>
        <Box sx={styles.chipContainer}>
          {hero.skills.map((skill) => (
            <Chip key={skill} label={skill} sx={styles.chip} />
          ))}
        </Box>
      </Box>

      {/* Note */}
      <Paper elevation={0} sx={styles.noteContainer}>
        <Typography variant="body1" sx={{ fontStyle: 'italic', fontWeight: 'bold' }}>
          {note.text}
        </Typography>
      </Paper>

      {/* About Section */}
      <Box sx={styles.section}>
        <Typography variant="h4" sx={styles.sectionTitle}>
          {about.title}
        </Typography>
        <Typography 
          variant="body2" 
          sx={{ textAlign: 'center', mb: 1, fontStyle: 'italic', color: 'text.secondary' }}
        >
          {about.note}
        </Typography>
        <Paper elevation={0} sx={styles.glassCard}>
          <Typography variant="body1" paragraph sx={{ lineHeight: 1.6 }}>
            {about.description}
          </Typography>
        </Paper>
      </Box>

      {/* Experience Grid */}
      <Box sx={styles.section}>
        <Typography variant="h3" sx={styles.sectionTitle}>
          {experience.title}
        </Typography>
        <Grid container spacing={4}>
          {experience.items.map((exp) => {
            const Icon = exp.icon;
            return (
              <Grid item xs={12} sm={6} md={4} key={exp.path}>
                <Paper
                  elevation={0}
                  onClick={() => navigate(exp.path)}
                  sx={styles.experienceCard}
                >
                  <Box sx={{ mb: 2 }}>
                    <Icon />
                  </Box>
                  <Typography variant="h6">
                    {exp.name}
                  </Typography>
                </Paper>
              </Grid>
            );
          })}
        </Grid>
      </Box>
    </Container>
  );
};

export default Home;
